import { SuspensePage } from '@/shared/ui/layout/SuspensePage';
import { PagesStaffNewMain } from './modules/ui/Main';

const StaffNewPage = (
  <SuspensePage>
    <PagesStaffNewMain />
  </SuspensePage>
);

export default StaffNewPage;
